exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-pano{width:100%;height:100%;margin:0;padding:0;border:0}.v-pano>div:last-child>span:last-child>span:last-child{width:60%!important}@media (min-width:768px){.v-pano>div:last-child>span:last-child>span:last-child{width:90%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/motor-show/Pano.vue?vue&type=style&index=0&lang=scss&
// module id = Zrsk
// module chunks = 8